export default __webpack_public_path__ + "static/media/989.215a41b1.gif";